import { Box, IconButton, Modal } from '@wix/design-system';
import { X } from '@wix/wix-ui-icons-common';

import css from './index.module.scss';

type ImageFullscreenOverlayProps = {
  url: string;
  onClose: () => void;
};

const OVERLAY_Z_INDEX = 999999;

const ImageFullscreenOverlay = ({ url, onClose }: ImageFullscreenOverlayProps) => (
  <Modal
    isOpen
    contentLabel="image preview"
    zIndex={OVERLAY_Z_INDEX}
    onRequestClose={onClose}
    shouldCloseOnOverlayClick
  >
    <Box className={css.content}>
      <img src={url} alt="" className={css.image} />
      <Box className={css.closeButton}>
        <IconButton size="tiny" skin="standard" priority="secondary" onClick={onClose}>
          <X />
        </IconButton>
      </Box>
    </Box>
  </Modal>
);

export default ImageFullscreenOverlay;
